import React, { useState } from 'react'
import PropTypes from 'prop-types'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Typography
} from '@material-ui/core'
import { useTrans } from '../../../services/i18n'
import connect from '../connect'

const StatusManagementModal = ({ 
  open, 
  onClose, 
  form, 
  updateFormAdminStatus, 
  fetchList 
}) => {
  const { trans } = useTrans()
  const [selectedStatus, setSelectedStatus] = useState(form?.adminStatus || 'new')
  const [loading, setLoading] = useState(false)

  const statusOptions = [
    { value: 'new', label: trans('new') },
    { value: 'pending', label: trans('pending') },
    { value: 'closed', label: trans('closed') },
    { value: 'qualified', label: trans('qualified') },
    { value: 'disqualified', label: trans('disqualified') }
  ]

  const handleStatusChange = (event) => {
    setSelectedStatus(event.target.value)
  }

  const handleSave = async () => {
    if (!form?.id || selectedStatus === form?.adminStatus) {
      onClose()
      return
    }

    setLoading(true)
    try {
      await updateFormAdminStatus({
        forms: [{
          organizationFormId: form.id,
          adminStatus: selectedStatus
        }]
      })
      fetchList()
      onClose()
    } catch (error) {
      console.error('Error updating admin status:', error)
    } finally {
      setLoading(false)
    }
  }

  const handleClose = () => {
    setSelectedStatus(form?.adminStatus || 'new')
    onClose()
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle style={{ padding: '20px 20px 0 20px' }}>
        <Typography variant="h6" component="div" style={{ fontWeight: 'bold' }}>
          {trans('status-management')}
        </Typography>
      </DialogTitle>
      
      <DialogContent style={{ padding: '20px' }}>
        <Box mt={2}>
          <Typography variant="body2" color="textSecondary" gutterBottom>
            {trans('worksheet')}: {form?.formName || 'N/A'}
          </Typography>
          <Typography variant="body2" color="textSecondary" gutterBottom>
            {trans('organization')}: {form?.organizationName || 'N/A'}
          </Typography>
        </Box>

        <Box mt={3}>
          <FormControl fullWidth variant="outlined">
            <InputLabel>{trans('admin-status')}</InputLabel>
            <Select
              value={selectedStatus}
              onChange={handleStatusChange}
              label={trans('admin-status')}
            >
              {statusOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        {selectedStatus !== form?.adminStatus && (
          <Box mt={2}>
            <Typography variant="body2" color="primary">
              {trans('status-will-change-from')} "{form?.adminStatus}" {trans('to')} "{selectedStatus}"
            </Typography>
          </Box>
        )}
      </DialogContent>

      <DialogActions style={{ padding: '20px' }}>
        <Button 
          onClick={handleClose} 
          color="default"
          disabled={loading}
        >
          {trans('cancel')}
        </Button>
        <Button 
          onClick={handleSave} 
          color="primary" 
          variant="contained"
          disabled={loading || selectedStatus === form?.adminStatus}
        >
          {loading ? trans('saving') : trans('save')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

StatusManagementModal.propTypes = {
  form: PropTypes.shape({
    id: PropTypes.string,
    formName: PropTypes.string,
    organizationName: PropTypes.string,
    adminStatus: PropTypes.string,
  }),
}

export default connect(StatusManagementModal)